import styled from 'styled-components'
import { Text } from 'sutra/components/Text/Text'
import { textSizeStyles } from 'sutra/components/Text/text-styles'
import { brand, gray } from 'sutra/tokens/colors'
import { spacing } from 'sutra/tokens/spacing'

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${spacing[6]}px;
  padding: 0 0 ${spacing[6]}px;
`

export const Left = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]}px;
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]}px;
`

// Sutra Heading level 4 adds -0.02em tracking; letter-spacing pinned to 0.
export const PageTitle = styled.h1`
  font-family: 'Poppins', system-ui, sans-serif;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: 0;
  color: ${brand.stillNight[800]};
  margin: 0;
`

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]}px;
  flex-wrap: wrap;
  min-height: 20px;
  color: ${gray[600]};
`

export const MetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]}px;
  color: ${gray[600]};
`

// styled(Text) drops `$size`, so the size is restated here.
export const MetaText = styled(Text)`
  ${textSizeStyles.sm}
  color: ${gray[600]};
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]}px;
  flex-shrink: 0;
`
